module.exports = __webpack_public_path__ + "static/img/animales_27.e7e33415.jpeg";